"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.settingsForm.titleCreate': '添加WhatsApp电话号码',
    'whatsapp.settingsForm.titleEdit': '编辑WhatsApp电话号码',
    'whatsapp.settingsForm.back': '返回',
    'whatsapp.settingsForm.loadFailed': '无法加载WhatsApp配置。',
};
